module.exports = __webpack_public_path__ + "img/2.9194ef40.jpg";